import React, { forwardRef, memo, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/hooks';

import { washHub } from 'store/slices';

import { createItemWithoutEPC } from 'api/items';
import { useMutation, useQueryClient } from 'react-query';

import { successToast } from 'utils/successToast';

import { RefType, AddItemModalProps } from './AddManualItemModal.props';

import AddItemModalView from './AddManualItemModal.view';

const Container = forwardRef<RefType, AddItemModalProps>((_, ref) => {
  const queryClient = useQueryClient();

  const washHubId = washHub.selectors.useSelectedWashHubId();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { mutate, isLoading } = useMutation(createItemWithoutEPC, {
    onSuccess: () => {
      successToast('Items created successfully');

      queryClient.invalidateQueries(`fetch-items-${washHubId}`);

      queryClient.invalidateQueries(`fetch-items-status-count-${washHubId}`, {
        exact: true,
      });
      onClose();
    },
  });

  useImperativeHandle(
    ref,
    () => ({
      onOpen,
    }),
    [onOpen],
  );
  const washHubSelected = washHub.selectors.useSelectedWashHub()?._id;
  const onSubmit = (values: any) => {
    values = {
      ...values,
      quantity: Number(values.quantity || '0'),
      washHub: washHubSelected,
    };
    mutate(values);
  };

  const _props = {
    isOpen,
    onClose,
    onSubmit,
    isLoading,
  };

  return <AddItemModalView {..._props} />;
});

const AddItemModal = memo(Container);

export default AddItemModal;
